// The sign-in screen with its account calls: the auth config (which other ways to sign in the server offers), REST
// login and register, Steam (the web round trip, or the desktop app's ticket). It hands the token on; the caller starts
// the session (the sign-in entry loads the game first).
// It carries data-boot-stage so it shows over a console still hidden under the boot (index.html gc-booting).

import { useEffect, useState } from 'react';
import { authConfig, login, markSsoStarted, register } from '../../adapter/net/auth';
import { desktopBridge, startSteamSignIn, steamTicketSignIn } from '../../adapter/net/steam';
import { SignOn, type SignOnMethods } from './SignOn';

let config: Promise<SignOnMethods> | null = null;
/** The server's auth config, asked once a page (the sign-in entry asks it before its first render). */
export function authOptions(): Promise<SignOnMethods> {
  // inside the Steam app the Steam button always shows (its ticket sign-in has no flag); on the web steam_signin decides
  return (config ??= authConfig().then((c) => ({ sso: c.sso === true, steam: c.steam === true || desktopBridge() !== null })));
}

export function SignInScreen({ build, detail, onToken }: { build: string; detail?: string | null; onToken: (token: string) => void | Promise<void> }) {
  const [methods, setMethods] = useState<SignOnMethods>({ sso: false });
  useEffect(() => {
    let on = true;
    void authOptions().then((c) => on && setMethods(c));
    return () => {
      on = false;
    };
  }, []);
  return (
    <div data-boot-stage="signin">
      <SignOn
        build={build}
        methods={methods}
        detail={detail}
        onSso={() => markSsoStarted()}
        onSteam={async () => {
          // inside the desktop app the Steam client's ticket signs in here; on the web the page goes to Steam and comes
          // back with the token (#sso=) or the refusal (#ssoError=)
          if (desktopBridge()) await onToken((await steamTicketSignIn()).token);
          else location.assign(startSteamSignIn());
        }}
        onSubmit={async (mode, user, pass) => {
          const r = mode === 'login' ? await login(user, pass) : await register(user, pass);
          await onToken(r.token);
        }}
      />
    </div>
  );
}
